import { makeConsentProvider } from './_provider.js';

const AutoAllowCookiesProvider = makeConsentProvider({
  hasConsented: () => true,
  handleRequestConsent: () => {
  },
  subscribe: () => {
    return () => {
    };
  }
});

export { AutoAllowCookiesProvider };
//# sourceMappingURL=integration.auto-allow.js.map
